var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _g2, _path143, _path144, _path145, _path146, _g3, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentSreUseCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 196,
    viewBox: "0 0 224 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 103.849L90.5068 93.5195V114.177L108.397 124.505L126.287 114.177V93.5195L108.397 103.849Z",
    fill: "#9898E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 124.506L90.5068 114.177V93.5195L108.397 103.849V124.506Z",
    fill: "#9898E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.287 114.177L108.396 124.506V103.849L126.287 93.5195V114.177Z",
    fill: "#232376"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 103.847L90.5068 93.5177L108.397 83.1895L126.287 93.5184L108.397 103.847Z",
    fill: "#9898E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 103.845L91.2826 93.9648L90.5068 94.4126L108.397 104.742L126.287 94.4126L125.511 93.9648L108.397 103.845Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 117.106L113.745 106.777V127.434L131.635 137.763L149.525 127.434V106.777L131.635 117.106Z",
    fill: "#9898E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 137.763L113.745 127.434V106.777L131.635 117.106V137.763Z",
    fill: "#9898E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.525 127.434L131.635 137.763V117.106L149.525 106.777V127.434Z",
    fill: "#232376"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 117.104L113.745 106.776L131.634 96.4473L149.524 106.776L131.635 117.104Z",
    fill: "#9898E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 117.104L114.521 107.223L113.745 107.67L131.635 117.999L149.524 107.671L148.748 107.223L131.635 117.104Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 130.364L136.982 120.035V140.692L154.872 151.021L172.763 140.692V120.035L154.872 130.364Z",
    fill: "#9898E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.873 151.021L136.982 140.692V120.035L154.873 130.364V151.021Z",
    fill: "#9898E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.763 140.692L154.873 151.021V130.364L172.763 120.035V140.692Z",
    fill: "#232376"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.873 130.362L136.982 120.033L154.872 109.705L172.762 120.034L154.873 130.362Z",
    fill: "#9898E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 130.364L137.758 120.484L136.982 120.931L154.872 131.26L172.762 120.931L172.763 120.035L154.872 130.364Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 118.002L67.2695 107.674V128.33L85.1594 138.659L103.049 128.33V107.674L85.1594 118.002Z",
    fill: "#9898E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 138.659L67.2695 128.33V107.674L85.1594 118.002V138.659Z",
    fill: "#9898E2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.049 128.33L85.1592 138.659V118.002L103.049 107.674V128.33Z",
    fill: "#232376"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 118.001L67.2695 107.673L85.1587 97.3438L103.049 107.673L85.1594 118.001Z",
    fill: "#9898E2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 118L68.0453 108.119L67.2695 108.567L85.1594 118.896L103.049 108.568L102.273 108.119L85.1594 118Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 131.261L90.5068 120.932V141.589L108.397 151.917L126.287 141.589V120.932L108.397 131.261Z",
    fill: "#9898E2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 151.918L90.5068 141.589V120.932L108.397 131.261V151.918Z",
    fill: "#9898E2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.287 141.589L108.396 151.918V131.261L126.287 120.932V141.589Z",
    fill: "#232376"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 131.259L90.5068 120.93L108.397 110.602L126.287 120.931L108.397 131.259Z",
    fill: "#9898E2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 131.257L91.2826 121.377L90.5068 121.825L108.397 132.154L126.287 121.825L125.511 121.377L108.397 131.257Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 144.522L113.745 134.193V154.85L131.635 165.179L149.525 154.85V134.193L131.635 144.522Z",
    fill: "#9898E2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 165.179L113.745 154.85V134.193L131.635 144.522V165.179Z",
    fill: "#9898E2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M149.525 154.85L131.635 165.179V144.522L149.525 134.193V154.85Z",
    fill: "#232376"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 144.521L113.745 134.192L131.634 123.863L149.524 134.192L131.635 144.521Z",
    fill: "#9898E2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 144.522L114.521 134.641L113.745 135.089L131.635 145.418L149.524 135.09L149.525 134.193L131.635 144.522Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 132.159L44.0312 121.83V142.487L61.9211 152.816L79.811 142.487V121.83L61.9211 132.159Z",
    fill: "#9898E2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 152.816L44.0312 142.487V121.83L61.9211 132.159V152.816Z",
    fill: "#9898E2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8108 142.487L61.9209 152.816V132.159L79.8108 121.83V142.487Z",
    fill: "#232376"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 132.157L44.0312 121.828L61.9211 111.5L79.811 121.828L61.9211 132.157Z",
    fill: "#9898E2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 132.159L44.0312 121.83V122.726L61.9211 133.055L79.811 122.726L79.0352 122.279L61.9211 132.159Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 145.419L67.2695 135.09V155.746L85.1594 166.075L103.049 155.746V135.09L85.1594 145.419Z",
    fill: "#9898E2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 166.075L67.2695 155.746V135.09L85.1594 145.418V166.075Z",
    fill: "#9898E2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103.049 155.746L85.1592 166.075V145.418L103.049 135.09V155.746Z",
    fill: "#232376"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 145.417L67.2695 135.089L85.1587 124.76L103.049 135.089L85.1594 145.417Z",
    fill: "#9898E2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 145.42L67.2695 135.09V135.986L85.1594 146.315L103.049 135.987L102.273 135.538L85.1594 145.42Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 158.675L90.5068 148.346V169.003L108.397 179.331L126.287 169.003V148.346L108.397 158.675Z",
    fill: "#9898E2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 179.332L90.5068 169.003V148.346L108.397 158.675V179.332Z",
    fill: "#9898E2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M126.287 169.003L108.396 179.332V158.675L126.287 148.346V169.003Z",
    fill: "#232376"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 158.673L90.5068 148.344L108.397 138.016L126.287 148.345L108.397 158.673Z",
    fill: "#9898E2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 158.675L90.5068 148.346V149.242L108.397 159.571L126.287 149.242V148.346L108.397 158.675Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 76.4364L90.5068 66.1074V86.7647L108.397 97.0936L126.287 86.7647V66.1074L108.397 76.4364Z",
    fill: "#9898E2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 97.0929L90.5068 86.764V66.1074L108.397 76.4357V97.0929Z",
    fill: "#9898E2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M126.287 86.764L108.396 97.0929V76.4357L126.287 66.1074V86.764Z",
    fill: "#232376"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 76.4346L90.5068 66.1063L108.397 55.7773L126.287 66.1063L108.397 76.4346Z",
    fill: "#9898E2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 76.4332L91.2826 66.5527L90.5068 67.0005L108.397 77.3295L126.287 67.0005L125.511 66.5527L108.397 76.4332Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M108.396 155.314L96.1924 148.269L108.396 141.223L120.6 148.269L108.396 155.314Z",
    fill: "#4E5958"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M85.1587 142.053L72.9551 135.007L85.1587 127.961L97.3623 135.007L85.1587 142.053Z",
    fill: "#4E5958"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M131.634 141.156L119.431 134.11L131.634 127.064L143.838 134.11L131.634 141.156Z",
    fill: "#4E5958"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M154.917 127.164L142.713 120.118L154.917 113.072L167.12 120.118L154.917 127.164Z",
    fill: "#4E5958"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.9204 128.792L49.7168 121.746L61.9204 114.701L74.124 121.747L61.9204 128.792Z",
    fill: "#4E5958"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 89.6942L113.745 79.3652V100.022L131.635 110.351L149.525 100.022V79.3652L131.635 89.6942Z",
    fill: "#9898E2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 110.351L113.745 100.022V79.3652L131.635 89.6942V110.351Z",
    fill: "#9898E2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M149.525 100.022L131.635 110.351V89.6942L149.525 79.3652V100.022Z",
    fill: "#232376"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 89.6924L113.745 79.3634L131.634 69.0352L149.524 79.3641L131.635 89.6924Z",
    fill: "#9898E2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 89.6918L114.521 79.8105L113.745 80.259L131.635 90.5873L149.524 80.259L148.748 79.8113L131.635 89.6918Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 102.952L136.982 92.623V113.28L154.872 123.609L172.763 113.28V92.623L154.872 102.952Z",
    fill: "#9898E2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M154.873 123.609L136.982 113.28V92.623L154.873 102.951V123.609Z",
    fill: "#9898E2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.763 113.28L154.873 123.609V102.951L172.763 92.623V113.28Z",
    fill: "#232376"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M154.873 102.95L136.982 92.6219L154.872 82.293L172.762 92.6219L154.873 102.95Z",
    fill: "#9898E2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 102.952L137.758 93.0708L136.982 93.5186L154.872 103.848L172.762 93.5193L172.763 92.623L154.872 102.952Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 90.5907L67.2695 80.2617V100.918L85.1594 111.247L103.049 100.918V80.2617L85.1594 90.5907Z",
    fill: "#9898E2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 111.247L67.2695 100.919V80.2617L85.1594 90.5907V111.247Z",
    fill: "#9898E2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M103.049 100.919L85.1592 111.247V90.5907L103.049 80.2617V100.919Z",
    fill: "#232376"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 90.5889L67.2695 80.2599L85.1587 69.9316L103.049 80.2599L85.1594 90.5889Z",
    fill: "#9898E2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 90.5882L68.0453 80.707L67.2695 81.1548L85.1594 91.4838L103.049 81.1555L102.273 80.7077L85.1594 90.5882Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 103.849L90.5068 93.5195V114.177L108.397 124.506L126.287 114.177V93.5195L108.397 103.849Z",
    fill: "#9898E2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 124.506L90.5068 114.177V93.5195L108.397 103.849V124.506Z",
    fill: "#9898E2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M126.287 114.177L108.396 124.506V103.849L126.287 93.5195V114.177Z",
    fill: "#232376"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 103.847L90.5068 93.5177L108.397 83.1895L126.287 93.5184L108.397 103.847Z",
    fill: "#9898E2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 103.845L91.2826 93.9648L90.5068 94.4126L108.397 104.742L126.287 94.4126L125.511 93.9648L108.397 103.845Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 117.106L113.745 106.777V127.435L131.635 137.763L149.525 127.435V106.777L131.635 117.106Z",
    fill: "#9898E2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 137.763L113.745 127.435V106.777L131.635 117.106V137.763Z",
    fill: "#9898E2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M149.525 127.435L131.635 137.763V117.106L149.525 106.777V127.435Z",
    fill: "#232376"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 117.104L113.745 106.776L131.634 96.4473L149.524 106.776L131.635 117.104Z",
    fill: "#9898E2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 117.106L114.521 107.225L113.745 107.674L131.635 118.002L149.524 107.674L149.525 106.777L131.635 117.106Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 104.745L44.0312 94.416V115.073L61.9211 125.401L79.811 115.073V94.416L61.9211 104.745Z",
    fill: "#9898E2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 125.402L44.0312 115.073V94.416L61.9211 104.745V125.402Z",
    fill: "#9898E2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8108 115.073L61.9209 125.402V104.745L79.8108 94.416V115.073Z",
    fill: "#232376"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 104.743L44.0312 94.4142L61.9211 84.0859L79.811 94.4149L61.9211 104.743Z",
    fill: "#9898E2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 104.742L44.807 94.8613L44.0312 95.3091L61.9211 105.638L79.811 95.3091L79.0352 94.8613L61.9211 104.742Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 118.003L67.2695 107.674V128.33L85.1594 138.659L103.049 128.33V107.674L85.1594 118.003Z",
    fill: "#9898E2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 138.659L67.2695 128.33V107.674L85.1594 118.003V138.659Z",
    fill: "#9898E2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M103.049 128.33L85.1592 138.659V118.003L103.049 107.674V128.33Z",
    fill: "#232376"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 118.001L67.2695 107.672L85.1587 97.3438L103.049 107.672L85.1594 118.001Z",
    fill: "#9898E2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 118.003L67.2695 107.674V108.569L85.1594 118.898L103.049 108.57L102.273 108.122L85.1594 118.003Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 131.261L90.5068 120.932V141.589L108.397 151.918L126.287 141.589V120.932L108.397 131.261Z",
    fill: "#9898E2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 151.918L90.5068 141.589V120.932L108.397 131.261V151.918Z",
    fill: "#9898E2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M126.287 141.589L108.396 151.918V131.261L126.287 120.932V141.589Z",
    fill: "#232376"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 131.259L90.5068 120.93L108.397 110.602L126.287 120.931L108.397 131.259Z",
    fill: "#9898E2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 131.261L90.5068 120.932V121.828L108.397 132.157L126.287 121.828V120.932L108.397 131.261Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M154.917 99.871L142.713 92.8252L154.917 85.7793L167.12 92.8252L154.917 99.871Z",
    fill: "#4E5958"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.9204 101.5L49.7168 94.4541L61.9204 87.4082L74.124 94.4541L61.9204 101.5Z",
    fill: "#4E5958"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 49.0204L90.5068 38.6914V59.3479L108.397 69.6769L126.287 59.3479V38.6914L108.397 49.0204Z",
    fill: "#9898E2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 69.6769L90.5068 59.3479V38.6914L108.397 49.0204V69.6769Z",
    fill: "#9898E2"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M126.287 59.3479L108.396 69.6769V49.0204L126.287 38.6914V59.3479Z",
    fill: "#232376"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 49.0186L90.5068 38.6896L108.397 28.3613L126.287 38.6896L108.397 49.0186Z",
    fill: "#9898E2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 49.0204L90.5068 38.6914V39.5869L108.397 49.9159L126.287 39.5876V38.6914L108.397 49.0204Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 62.2801L113.745 51.9512V72.6084L131.635 82.9374L149.525 72.6084V51.9512L131.635 62.2801Z",
    fill: "#9898E2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 82.9374L113.745 72.6084V51.9512L131.635 62.2801V82.9374Z",
    fill: "#9898E2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M149.525 72.6084L131.635 82.9374V62.2801L149.525 51.9512V72.6084Z",
    fill: "#232376"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 62.2783L113.745 51.9494L131.634 41.6211L149.524 51.9501L131.635 62.2783Z",
    fill: "#9898E2"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M131.635 62.2801L113.745 51.9512V52.8474L131.635 63.1764L149.524 52.8474L149.525 51.9512L131.635 62.2801Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 75.5419L136.982 65.2129V85.8694L154.872 96.1984L172.763 85.8694V65.2129L154.872 75.5419Z",
    fill: "#9898E2"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M154.873 96.1984L136.982 85.8701V65.2129L154.873 75.5419V96.1984Z",
    fill: "#9898E2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M172.763 85.8701L154.873 96.1984V75.5419L172.763 65.2129V85.8701Z",
    fill: "#232376"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M154.873 75.54L136.982 65.2111L154.872 54.8828L172.762 65.2111L154.873 75.54Z",
    fill: "#9898E2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 75.5419L136.982 65.2129V66.1084L154.872 76.4374L172.762 66.1091L172.763 65.2129L154.872 75.5419Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 63.1766L67.2695 52.8477V73.5049L85.1594 83.8332L103.049 73.5049V52.8477L85.1594 63.1766Z",
    fill: "#9898E2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 83.8339L67.2695 73.5049V52.8477L85.1594 63.1766V83.8339Z",
    fill: "#9898E2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M103.049 73.5049L85.1592 83.8339V63.1766L103.049 52.8477V73.5049Z",
    fill: "#232376"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 63.1748L67.2695 52.8458L85.1587 42.5176L103.049 52.8465L85.1594 63.1748Z",
    fill: "#9898E2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1594 63.1766L67.2695 52.8477V53.7439L85.1594 64.0729L103.049 53.7439L103.049 52.8477L85.1594 63.1766Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 77.3283L44.0312 67V87.6565L61.9211 97.9855L79.811 87.6565V67L61.9211 77.3283Z",
    fill: "#9898E2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 97.9855L44.0312 87.6565V67L61.9211 77.3283V97.9855Z",
    fill: "#9898E2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8108 87.6565L61.9209 97.9855V77.3283L79.8108 67V87.6565Z",
    fill: "#232376"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 77.3272L44.0312 66.9989L61.9211 56.6699L79.811 66.9989L61.9211 77.3272Z",
    fill: "#9898E2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9211 77.3283L44.0312 67V67.8955L61.9211 78.2245L79.811 67.8962V67L61.9211 77.3283Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M209.222 144.522L194.74 136.16V152.882L209.222 161.243L223.704 152.882V136.16L209.222 144.522Z",
    fill: "#9898E2"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M209.222 161.243L194.74 152.882V136.16L209.222 144.522V161.243Z",
    fill: "#9898E2"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M223.704 152.882L209.222 161.243V144.522L223.704 136.16V152.882Z",
    fill: "#232376"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M209.222 144.522L194.74 136.161L209.222 127.801L223.703 136.162L209.222 144.522Z",
    fill: "#9898E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.222 144.522L195.369 136.523L194.74 136.886L209.222 145.247L223.703 136.886L223.075 136.524L209.222 144.522Z",
    fill: "white"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M209.222 137.155L194.74 128.794L209.222 120.434L223.703 128.795L209.222 137.155Z",
    fill: "#03002D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M209.222 105.64L194.74 97.2793V114L209.222 122.362L223.704 114V97.2793L209.222 105.64Z",
    fill: "#9898E2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M209.222 122.362L194.74 114V97.2793L209.222 105.64V122.362Z",
    fill: "#9898E2"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M223.704 114L209.222 122.362V105.64L223.704 97.2793V114Z",
    fill: "#232376"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M209.222 105.642L194.74 97.2807L209.222 88.9199L223.703 97.2807L209.222 105.642Z",
    fill: "#9898E2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M209.222 105.643L195.369 97.6445L194.74 98.0073L209.222 106.369L223.703 98.008L223.075 97.6452L209.222 105.643Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9632 44.0321L4.19531 38.3926V49.6709L13.9632 55.3104L23.7317 49.6709V38.3926L13.9632 44.0321Z",
    fill: "#9898E2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9632 55.3104L4.19531 49.6709V38.3926L13.9632 44.0321V55.3104Z",
    fill: "#9898E2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7314 49.6709L13.9629 55.3104V44.0321L23.7314 38.3926V49.6709Z",
    fill: "#232376"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9632 44.031L4.19531 38.3915L13.9632 32.752L23.731 38.3915L13.9632 44.031Z",
    fill: "#9898E2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.9632 74.6755L4.19531 69.036L13.9632 63.3965L23.731 69.036L13.9632 74.6755Z",
    fill: "#03002D"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9632 44.0299L4.61899 38.6348L4.19531 38.8792L13.9632 44.5187L23.731 38.8792L23.3073 38.6348L13.9632 44.0299Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.9632 90.5907L4.19531 84.9512V96.2295L13.9632 101.869L23.7317 96.2295V84.9512L13.9632 90.5907Z",
    fill: "#9898E2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.9632 101.87L4.19531 96.2302V84.9512L13.9632 90.5907V101.87Z",
    fill: "#9898E2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.7314 96.2302L13.9629 101.87V90.5907L23.7314 84.9512V96.2302Z",
    fill: "#232376"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.9632 90.5915L4.19531 84.952L13.9632 79.3125L23.731 84.952L13.9632 90.5915Z",
    fill: "#9898E2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9632 90.5943L4.61899 85.1992L4.19531 85.4436L13.9632 91.0832L23.731 85.4436L23.3073 85.1992L13.9632 90.5943Z",
    fill: "white"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.9628 179.331L0 171.27V187.392L13.9628 195.453L27.9256 187.392V171.27L13.9628 179.331Z",
    fill: "#9898E2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.9628 195.453L0 187.392V171.27L13.9628 179.331V195.453Z",
    fill: "#9898E2"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.9257 187.392L13.9629 195.453V179.331L27.9257 171.27V187.392Z",
    fill: "#232376"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.9628 179.332L0 171.27L13.9628 163.209L27.9249 171.27L13.9628 179.332Z",
    fill: "#9898E2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9628 179.331L0.60575 171.619L0 171.968L13.9628 180.03L27.9249 171.968L27.3198 171.619L13.9628 179.331Z",
    fill: "white"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.9628 174.132L0 166.071L13.9628 158.01L27.9249 166.071L13.9628 174.132Z",
    fill: "#03002D"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9628 148.919L0 140.857V156.98L13.9628 165.041L27.9256 156.98V140.857L13.9628 148.919Z",
    fill: "#9898E2"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9628 165.041L0 156.98V140.857L13.9628 148.919V165.041Z",
    fill: "#9898E2"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9257 156.98L13.9629 165.041V148.919L27.9257 140.857V156.98Z",
    fill: "#232376"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9628 148.919L0 140.858L13.9628 132.797L27.9249 140.858L13.9628 148.919Z",
    fill: "#9898E2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9628 148.921L0.60575 141.209L0 141.559L13.9628 149.62L27.9249 141.559L27.3198 141.21L13.9628 148.921Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9202 28.3622L44.0303 18.0332V38.6904L61.9202 49.0187L79.8101 38.6904V18.0332L61.9202 28.3622Z",
    fill: "#9898E2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9202 49.0187L44.0303 38.6904V18.0332L61.9202 28.3622V49.0187Z",
    fill: "#9898E2"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8098 38.6904L61.9199 49.0187V28.3622L79.8098 18.0332V38.6904Z",
    fill: "#232376"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9202 28.3604L44.0303 18.0314L61.9202 7.70312L79.8101 18.0314L61.9202 28.3604Z",
    fill: "#9898E2"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9205 35.6555C61.8752 35.6555 61.8284 35.6434 61.7873 35.62L60.5609 34.9116C60.4334 34.8379 60.3902 34.6756 60.4632 34.5481C60.5376 34.4199 60.7019 34.3802 60.8266 34.4503L61.9205 35.083L63.0151 34.4503C63.1412 34.3795 63.3042 34.4213 63.3786 34.5481C63.4522 34.6756 63.4083 34.8379 63.2808 34.9116L62.0537 35.62C62.0126 35.6434 61.9665 35.6555 61.9205 35.6555Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1832 33.4985C58.1378 33.4985 58.0918 33.4864 58.05 33.463L55.5398 32.0135C55.4123 31.9398 55.3691 31.7775 55.442 31.65C55.5164 31.5218 55.6808 31.4814 55.8055 31.5523L58.3156 33.0018C58.4432 33.0755 58.4864 33.2377 58.4134 33.3653C58.3638 33.4503 58.2745 33.4985 58.1832 33.4985ZM53.1621 30.5993C53.1168 30.5993 53.0707 30.5873 53.0289 30.5639L50.5188 29.1144C50.3913 29.0407 50.348 28.8784 50.421 28.7509C50.4954 28.6227 50.6598 28.583 50.7845 28.6531L53.2946 30.1027C53.4222 30.1764 53.4654 30.3386 53.3924 30.4661C53.3428 30.5519 53.2535 30.5993 53.1621 30.5993ZM48.1418 27.7009C48.0958 27.7009 48.0504 27.6889 48.0086 27.6655L45.4978 26.216C45.3702 26.1423 45.327 25.98 45.4 25.8525C45.4744 25.7243 45.6388 25.6839 45.7635 25.7547L48.2743 27.2043C48.4018 27.278 48.4451 27.4402 48.3721 27.5677C48.3225 27.6535 48.2332 27.7009 48.1418 27.7009ZM43.1208 24.8018C43.0755 24.8018 43.0294 24.7898 42.9876 24.7664L40.4775 23.3168C40.3499 23.2432 40.3067 23.0809 40.3797 22.9534C40.4541 22.8252 40.6177 22.7855 40.7431 22.8556L43.2533 24.3052C43.3808 24.3789 43.424 24.5411 43.3511 24.6686C43.3015 24.7544 43.2122 24.8018 43.1208 24.8018ZM38.1005 21.9027C38.0552 21.9027 38.0091 21.8907 37.9673 21.8673L35.4564 20.4177C35.3289 20.3441 35.2857 20.1818 35.3587 20.0543C35.4324 19.926 35.5967 19.8857 35.7221 19.9565L38.233 21.4061C38.3605 21.4798 38.4037 21.642 38.3308 21.7695C38.2812 21.8552 38.1919 21.9027 38.1005 21.9027Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0794 19.0058C33.0341 19.0058 32.988 18.9938 32.9462 18.9704L31.7191 18.2619C31.6369 18.2145 31.5859 18.1266 31.5859 18.0317C31.5859 17.9367 31.6362 17.8489 31.7191 17.8014L32.9462 17.0929C33.073 17.0221 33.2353 17.0639 33.3097 17.1907C33.3826 17.3182 33.3394 17.4805 33.2119 17.5541L32.383 18.0324L33.2119 18.5106C33.3394 18.5843 33.3826 18.7465 33.3097 18.8741C33.2601 18.9577 33.1708 19.0058 33.0794 19.0058Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5902 16.1387C35.4988 16.1387 35.4096 16.0912 35.36 16.0055C35.2863 15.878 35.3302 15.7164 35.4577 15.642L37.9679 14.1925C38.0919 14.1209 38.2555 14.162 38.3313 14.2903C38.405 14.4178 38.3611 14.5793 38.2336 14.6537L35.7234 16.1033C35.6816 16.1266 35.6363 16.1387 35.5902 16.1387ZM40.6105 13.2403C40.5191 13.2403 40.4299 13.1928 40.3803 13.1071C40.3073 12.9796 40.3505 12.8173 40.478 12.7436L42.9889 11.2941C43.1129 11.2225 43.2766 11.2636 43.3524 11.3919C43.4253 11.5194 43.3821 11.6816 43.2546 11.7553L40.7437 13.2049C40.7019 13.2282 40.6566 13.2403 40.6105 13.2403ZM45.6316 10.3412C45.5402 10.3412 45.4509 10.2937 45.4013 10.208C45.3276 10.0805 45.3715 9.91892 45.4991 9.84453L48.0092 8.39497C48.1332 8.32341 48.2969 8.3645 48.3727 8.49274C48.4464 8.62027 48.4024 8.7818 48.2749 8.85619L45.7647 10.3057C45.7229 10.3298 45.6776 10.3412 45.6316 10.3412ZM50.6519 7.44277C50.5605 7.44277 50.4712 7.3953 50.4216 7.30957C50.3486 7.18204 50.3918 7.0198 50.5194 6.94612L53.0302 5.49657C53.1542 5.42501 53.3179 5.4661 53.3937 5.59434C53.4667 5.72186 53.4234 5.88411 53.2959 5.95779L50.7851 7.40734C50.7433 7.43143 50.6979 7.44277 50.6519 7.44277ZM55.6729 4.54366C55.5815 4.54366 55.4922 4.49619 55.4426 4.41046C55.3689 4.28293 55.4129 4.1214 55.5404 4.04701L58.0505 2.59746C58.1752 2.5259 58.3389 2.56699 58.414 2.69523C58.487 2.82275 58.4438 2.98428 58.3162 3.05868L55.8061 4.50823C55.7643 4.53232 55.7189 4.54366 55.6729 4.54366Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1471 1.64645C63.1017 1.64645 63.0557 1.63441 63.0139 1.61103L61.9193 0.978349L60.8247 1.61103C60.7 1.68258 60.5363 1.64078 60.4612 1.51325C60.3882 1.38573 60.4315 1.22348 60.559 1.1498L61.7868 0.44132C61.8683 0.39456 61.971 0.39456 62.0525 0.44132L63.2796 1.1498C63.4071 1.22348 63.4503 1.38573 63.3773 1.51325C63.3277 1.59827 63.2385 1.64645 63.1471 1.64645Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2505 16.1407C88.2045 16.1407 88.1592 16.1287 88.1174 16.1053L85.6065 14.6557C85.479 14.5821 85.4357 14.4198 85.5087 14.2923C85.5824 14.1641 85.7468 14.1237 85.8722 14.1945L88.383 15.6441C88.5106 15.7178 88.5538 15.88 88.4808 16.0075C88.4305 16.0925 88.3412 16.1407 88.2505 16.1407ZM83.2295 13.2416C83.1842 13.2416 83.1381 13.2296 83.0963 13.2062L80.5862 11.7566C80.4586 11.6829 80.4154 11.5207 80.4884 11.3932C80.5628 11.2649 80.7272 11.2246 80.8519 11.2954L83.362 12.745C83.4895 12.8186 83.5328 12.9809 83.4598 13.1084C83.4102 13.1941 83.3202 13.2416 83.2295 13.2416ZM78.2092 10.3425C78.1639 10.3425 78.1178 10.3305 78.076 10.3071L75.5652 8.85751C75.4376 8.78383 75.3944 8.62159 75.4674 8.49406C75.5418 8.36583 75.7061 8.32615 75.8308 8.39629L78.3417 9.84585C78.4692 9.91953 78.5124 10.0818 78.4395 10.2093C78.3899 10.295 78.3006 10.3425 78.2092 10.3425ZM73.1882 7.44409C73.1429 7.44409 73.0968 7.43205 73.055 7.40867L70.5448 5.95911C70.4173 5.88543 70.3741 5.72319 70.4471 5.59566C70.5208 5.46743 70.6851 5.42704 70.8105 5.49789L73.3207 6.94745C73.4482 7.02113 73.4914 7.18337 73.4185 7.3109C73.3689 7.39662 73.2796 7.44409 73.1882 7.44409ZM68.1672 4.54498C68.1218 4.54498 68.0758 4.53294 68.034 4.50956L65.5238 3.06C65.3963 2.98632 65.3531 2.82408 65.4261 2.69655C65.4997 2.56831 65.6641 2.52864 65.7895 2.59878L68.2997 4.04833C68.4272 4.12201 68.4704 4.28426 68.3974 4.41178C68.3478 4.49751 68.2586 4.54498 68.1672 4.54498Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7611 19.0056C90.6697 19.0056 90.5805 18.9581 90.5309 18.8724C90.4572 18.7449 90.5011 18.5826 90.6286 18.509L91.4575 18.0307L90.6286 17.5525C90.5011 17.4788 90.4579 17.3166 90.5309 17.1891C90.6045 17.0608 90.7689 17.0204 90.8943 17.0913L92.1214 17.7998C92.2036 17.8472 92.2546 17.9351 92.2546 18.03C92.2546 18.125 92.2043 18.2128 92.1214 18.2603L90.8943 18.9688C90.8518 18.9936 90.8057 19.0056 90.7611 19.0056Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6586 33.4981C65.5672 33.4981 65.4779 33.4506 65.4283 33.3649C65.3546 33.2373 65.3986 33.0758 65.5261 33.0014L68.0362 31.5519C68.1609 31.4803 68.3246 31.5214 68.3997 31.6496C68.4734 31.7772 68.4295 31.9387 68.3019 32.0131L65.7918 33.4626C65.75 33.486 65.7039 33.4981 65.6586 33.4981ZM70.6789 30.5989C70.5875 30.5989 70.4982 30.5515 70.4486 30.4658C70.3749 30.3382 70.4189 30.176 70.5464 30.1023L73.0573 28.6527C73.1834 28.5812 73.3463 28.6237 73.4207 28.7505C73.4937 28.878 73.4505 29.0403 73.323 29.114L70.8121 30.5635C70.7703 30.5869 70.7235 30.5989 70.6789 30.5989ZM75.6999 27.7005C75.6085 27.7005 75.5192 27.6531 75.4697 27.5673C75.3967 27.4398 75.4399 27.2783 75.5674 27.2039L78.0776 25.7543C78.2016 25.6828 78.3652 25.7239 78.441 25.8521C78.5147 25.9796 78.4708 26.1412 78.3433 26.2156L75.8331 27.6651C75.7913 27.6885 75.7452 27.7005 75.6999 27.7005ZM80.7202 24.8014C80.6288 24.8014 80.5396 24.754 80.49 24.6682C80.417 24.5407 80.4602 24.3785 80.5877 24.3048L83.0986 22.8552C83.2247 22.7844 83.387 22.8262 83.462 22.953C83.5357 23.0805 83.4918 23.2428 83.3643 23.3165L80.8534 24.766C80.8109 24.7901 80.7655 24.8014 80.7202 24.8014ZM85.7412 21.903C85.6498 21.903 85.5606 21.8556 85.511 21.7698C85.4373 21.6423 85.4812 21.4808 85.6088 21.4064L88.1189 19.9568C88.2429 19.8853 88.4065 19.9264 88.4824 20.0546C88.5553 20.1821 88.5121 20.3437 88.3846 20.418L85.8744 21.8676C85.8319 21.8917 85.7866 21.903 85.7412 21.903Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9202 28.3622L44.0303 18.0332V18.9287L61.9202 29.2577L79.8101 18.9294V18.0332L61.9202 28.3622Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8526 97.9418C31.7059 97.9418 31.5869 97.8228 31.5869 97.6762V97.244C31.5869 97.0973 31.7059 96.9783 31.8526 96.9783C31.9993 96.9783 32.1183 97.0973 32.1183 97.244V97.6762C32.1183 97.8228 31.9993 97.9418 31.8526 97.9418ZM31.8526 94.675C31.7059 94.675 31.5869 94.556 31.5869 94.4093V91.5754C31.5869 91.4287 31.7059 91.3097 31.8526 91.3097C31.9993 91.3097 32.1183 91.4287 32.1183 91.5754V94.4093C32.1183 94.556 31.9993 94.675 31.8526 94.675ZM31.8526 89.0072C31.7059 89.0072 31.5869 88.8881 31.5869 88.7415V85.9075C31.5869 85.7609 31.7059 85.6419 31.8526 85.6419C31.9993 85.6419 32.1183 85.7609 32.1183 85.9075V88.7415C32.1183 88.8881 31.9993 89.0072 31.8526 89.0072ZM31.8526 83.3393C31.7059 83.3393 31.5869 83.2203 31.5869 83.0736V80.2397C31.5869 80.093 31.7059 79.974 31.8526 79.974C31.9993 79.974 32.1183 80.093 32.1183 80.2397V83.0736C32.1183 83.2203 31.9993 83.3393 31.8526 83.3393ZM31.8526 77.6714C31.7059 77.6714 31.5869 77.5524 31.5869 77.4057V74.5718C31.5869 74.4252 31.7059 74.3061 31.8526 74.3061C31.9993 74.3061 32.1183 74.4252 32.1183 74.5718V77.4057C32.1183 77.5524 31.9993 77.6714 31.8526 77.6714ZM31.8526 72.0036C31.7059 72.0036 31.5869 71.8845 31.5869 71.7379V68.904C31.5869 68.7573 31.7059 68.6383 31.8526 68.6383C31.9993 68.6383 32.1183 68.7573 32.1183 68.904V71.7379C32.1183 71.8845 31.9993 72.0036 31.8526 72.0036ZM31.8526 66.3357C31.7059 66.3357 31.5869 66.2167 31.5869 66.07V63.2361C31.5869 63.0894 31.7059 62.9704 31.8526 62.9704C31.9993 62.9704 32.1183 63.0894 32.1183 63.2361V66.07C32.1183 66.2167 31.9993 66.3357 31.8526 66.3357ZM31.8526 60.6678C31.7059 60.6678 31.5869 60.5488 31.5869 60.4022V57.5682C31.5869 57.4216 31.7059 57.3025 31.8526 57.3025C31.9993 57.3025 32.1183 57.4216 32.1183 57.5682V60.4022C32.1183 60.5488 31.9993 60.6678 31.8526 60.6678ZM31.8526 55C31.7059 55 31.5869 54.881 31.5869 54.7343V51.9004C31.5869 51.7537 31.7059 51.6347 31.8526 51.6347C31.9993 51.6347 32.1183 51.7537 32.1183 51.9004V54.7343C32.1183 54.881 31.9993 55 31.8526 55ZM31.8526 49.3321C31.7059 49.3321 31.5869 49.2131 31.5869 49.0664V46.2325C31.5869 46.0859 31.7059 45.9668 31.8526 45.9668C31.9993 45.9668 32.1183 46.0859 32.1183 46.2325V49.0664C32.1183 49.2131 31.9993 49.3321 31.8526 49.3321ZM31.8526 43.6643C31.7059 43.6643 31.5869 43.5452 31.5869 43.3986V40.5646C31.5869 40.418 31.7059 40.299 31.8526 40.299C31.9993 40.299 32.1183 40.418 32.1183 40.5646V43.3986C32.1183 43.5452 31.9993 43.6643 31.8526 43.6643ZM31.8526 37.9964C31.7059 37.9964 31.5869 37.8774 31.5869 37.7307V35.7307C31.5869 35.6343 31.6386 35.5458 31.7229 35.499L32.4498 35.0923C32.5759 35.0215 32.7389 35.0654 32.8112 35.1951C32.8834 35.3233 32.8374 35.4848 32.7084 35.5564L32.1176 35.8872V37.7321C32.1183 37.8774 31.9993 37.9964 31.8526 37.9964ZM35.0535 34.2053C34.9607 34.2053 34.87 34.1564 34.8218 34.07C34.7496 33.941 34.7956 33.7795 34.9239 33.708L37.3965 32.3243C37.5247 32.2527 37.6869 32.2981 37.7585 32.4263C37.8308 32.5553 37.7847 32.7168 37.6565 32.7883L35.1839 34.172C35.1421 34.194 35.0974 34.2053 35.0535 34.2053ZM39.9987 31.4366C39.9059 31.4366 39.8152 31.3877 39.767 31.3012C39.6948 31.1723 39.7408 31.0108 39.8691 30.9392L42.3417 29.5555C42.4699 29.4847 42.6314 29.5293 42.7037 29.6576C42.776 29.7865 42.7299 29.948 42.6017 30.0196L40.1291 31.4033C40.0873 31.4259 40.0434 31.4366 39.9987 31.4366ZM44.9453 28.6685C44.8525 28.6685 44.7618 28.6196 44.7137 28.5332C44.6414 28.4042 44.6875 28.2427 44.8157 28.1712L47.2883 26.7875C47.4158 26.7166 47.5781 26.7613 47.6503 26.8895C47.7226 27.0185 47.6766 27.18 47.5483 27.2515L45.0757 28.6352C45.0339 28.6579 44.9893 28.6685 44.9453 28.6685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentSreUseCase);
export default __webpack_public_path__ + "static/media/agent-sre-use-case.eb7ef9b1db0e3f954f945d92264f7c52.svg";
export { ForwardRef as ReactComponent };